// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Alert: {
    close: 'Close'
  },
  Card: {
    select: 'Auswählen',
    titleLinkTooltip: 'Seite öffnen',
    collapseCardTooltip: 'Karte minimieren',
    expandCardTooltip: 'Karte maximieren'
  },
  CardList: {
    loadMore: 'Mehr anzeigen',
    notFound: 'Keine Elemente gefunden.',
    toolbarSelect: 'Auswählen',
    viewCards: 'Karten',
    viewTiles: 'Kacheln',
    viewList: 'Liste',
    toolbarView: 'Ansicht'
  },
  Carousel: {
    nextSlide: 'Next slide',
    previousSlide: 'Previous slide',
    viewSlide: 'View slide %%slideNumber%%'
  },
  ComboBox: {
    close: 'Close',
    open: 'Open'
  },
  ClosingConfirmation: {
    confirm: 'Schließen',
    cancel: 'Zurück',
    content: 'Sind Sie sicher, dass Sie dieses Fenster schließen wollen? Ihre Änderungen werden nicht übernommen.'
  },
  Cuttable: {
    showMore: 'Mehr anzeigen',
    showLess: 'Weniger anzeigen'
  },
  Dialog: {
    closeButton: 'Close',
    cancelButton: 'Abbrechen'
  },
  Drawer: {
    backButton: 'Back',
    closeButton: 'Close',
    hideButton: 'Hide'
  },
  DrawerProgress: {
    cancelButton: 'Abbrechen'
  },
  Dropdown: {
    close: 'Schließen'
  },
  Form: {
    submitButton: 'Speichern',
    applyButton: 'Anwenden',
    cancelButton: 'Abbrechen'
  },
  FormField: {
    clear: 'Löschen',
    remove: 'Entfernen',
    addMore: 'Weiteres Element hinzufügen',
    showDescription: 'Show description'
  },
  FormFieldPassword: {
    improvePassword: 'So erhöhen Sie die Sicherheit Ihres Passworts:',
    passwordTooShort: 'Verwenden Sie ein längeres Passwort.',
    lettersLowerCase: 'Verwenden Sie mindestens einen Kleinbuchstaben.',
    lettersUpperCase: 'Verwenden Sie mindestens einen Großbuchstaben.',
    numbers1: 'Verwenden Sie mindestens eine Ziffer.',
    numbers3: 'Verwenden Sie mindestens drei Ziffern.',
    specialChar1: 'Verwenden Sie mindestens ein Sonderzeichen (zum Beispiel: !, @, #, $, %, ^, &, *, ?, _, ~).',
    specialChar2: 'Verwenden Sie mindestens zwei Sonderzeichen (zum Beispiel: !, @, #, $, %, ^, &, *, ?, _, ~).',
    comboUpperAndLower: 'Verwenden Sie sowohl Groß- als auch Kleinbuchstaben.',
    comboLettersAndNumbers: 'Verwenden Sie sowohl Ziffern als auch Zeichen.',
    comboLettersNumbersSpecial: 'Verwenden Sie sowohl Ziffern, Zeichen als auch Sonderzeichen.',
    yourPasswordIsStrong: 'Je länger das Passwort ist, umso sicherer ist es.',
    passwordStrength: 'Passwortsicherheit: %%strength%%.',
    strengthVeryStrong: 'SEHR SICHER',
    strengthStrong: 'SICHER',
    strengthVeryWeak: 'SEHR SCHWACH',
    strengthWeak: 'SCHWACH',
    strengthMedium: 'MITTEL',
    hidePassword: 'Passwort ausblenden',
    showPassword: 'Passwort einblenden',
    generateButton: 'Erstellen',
    copyButtonHint: 'Passwort kopieren',
    copySuccessToast: 'Passwort wurde kopiert',
    generateButtonHint: 'Sicheres Passwort erstellen'
  },
  InPlaceEdit: {
    cancelButtonHint: 'Änderungen verwerfen',
    editButtonHint: 'Wert bearbeiten',
    okButtonHint: 'Änderungen speichern'
  },
  InputNumber: {
    decrement: 'Decrement',
    increment: 'Increment'
  },
  InputFile: {
    browseButton: 'Datei auswählen...'
  },
  Layout: {
    openSidebar: 'Expand sidebar',
    closeSidebar: 'Collapse sidebar'
  },
  List: {
    totalRows: '%%totalRows%% Elemente insgesamt',
    toggleAllRows: 'Toggle all rows',
    toggleRow: 'Toggle row',
    selectedRows: '%%selectedRows%% von %%totalRows%% Elementen ausgewählt',
    all: 'Alle',
    allItemsOnPageSelected: 'Alle Elemente auf der Seite ausgewählt',
    allItemsSelected: 'Alle Elemente ausgewählt',
    selectAllItems: 'Alle Elemente auswählen',
    selectAllItemsOnPage: 'Alle Elemente auf der Seite auswählen',
    deselectAll: 'Auswahl aufheben',
    selectRow: 'Select row',
    selectAllRows: 'Select all rows'
  },
  ListActions: {
    menuButton: 'Open menu'
  },
  ListEmptyView: {
    filteredTitle: 'Keine mit dem Filter übereinstimmende Elemente gefunden',
    emptyTitle: 'Keine Elemente vorhanden',
    filteredDescription: 'Passen Sie Ihre Anfrage an oder entfernen Sie einige der Filterkriterien und versuchen Sie es erneut.'
  },
  ListOperation: {
    cancelButton: 'Abbrechen'
  },
  Panel: {
    collapse: 'Collapse',
    expand: 'Expand'
  },
  Pagination: {
    totalShort: 'von %%total%%',
    itemsPerPage: 'Elemente pro Seite',
    all: 'Alle',
    total: 'Seite %%current%% von %%total%%'
  },
  Popover: {
    closeButton: 'Close'
  },
  ProgressDialog: {
    closeButton: 'Schließen',
    cancelButton: 'Abbrechen'
  },
  Section: {
    collapse: 'Collapse',
    closeButton: 'Close',
    expand: 'Expand'
  },
  Select: {
    clearButton: 'Clear',
    noOptions: 'Keine Optionen',
    placeholder: 'Auswählen...'
  },
  SearchBar: {
    clearButton: 'Clear',
    searchButton: 'Search',
    collapseSearch: 'Hide search input',
    expandSearch: 'Show search input'
  },
  SpotPopup: {
    total: '%%current%% von %%total%%'
  },
  SwitchesPanelItem: {
    showDescription: 'Show description'
  },
  Tabs: {
    closeButton: 'Close tab'
  },
  Toaster: {
    closeGroup: 'Gruppe schließen'
  },
  Toast: {
    closeButton: 'Close'
  }
};